/**
 * PDF modal — iframe preview inside <dialog>.
 * Query viewer nodes from dialog (moved to body on open). Close via delegated click + Escape.
 */
(function () {
  function qs(sel, el) {
    return (el || document).querySelector(sel);
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('overflow-hidden', on);
  }

  function cleanUrl(raw) {
    var u = String(raw || '').trim().replace(/^["']+|["']+$/g, '');
    if (!u) return '';
    if (!/^https?:\/\//i.test(u)) u = u.indexOf('//') === 0 ? 'https:' + u : 'https://' + u;
    return u;
  }

  function shopPdfUrl(raw) {
    var u = cleanUrl(raw);
    if (!u) return '';
    if (u.indexOf('/cdn/shop/files/') !== -1 && u.indexOf(window.location.host) !== -1) {
      return u.split('#')[0];
    }
    var part = '';
    if (u.indexOf('/cdn/shop/files/') !== -1) part = u.split('/cdn/shop/files/').pop();
    else if (u.indexOf('/files/') !== -1) part = u.split('/files/').pop();
    part = (part || '').split('#')[0];
    if (!part || part.indexOf('.pdf') === -1) return '';
    return window.location.origin + '/cdn/shop/files/' + part;
  }

  function resolvePdfUrl(root, dialog) {
    var candidates = [];
    function add(raw) {
      if (!raw) return;
      var shop = shopPdfUrl(raw);
      var direct = cleanUrl(raw);
      [shop, direct].forEach(function (u) {
        if (u && u.indexOf('.pdf') !== -1 && candidates.indexOf(u) === -1) candidates.push(u);
      });
    }
    add(root.getAttribute('data-pdf-url'));
    dialog.querySelectorAll('[data-pdf-open-tab][href], a[href*=".pdf"]').forEach(function (a) {
      add(a.getAttribute('href'));
    });
    return candidates[0] || '';
  }

  function ensureIframe(dialog) {
    var wrap = qs('[data-pdf-viewer-wrap]', dialog);
    var frame = qs('[data-pdf-iframe]', dialog);
    if (!frame && wrap) {
      frame = document.createElement('iframe');
      frame.className = 'pdf-hub__viewer-frame';
      frame.setAttribute('data-pdf-iframe', '');
      frame.setAttribute('title', 'Technical Datasheet');
      frame.hidden = true;
      var fallback = qs('[data-pdf-fallback]', dialog);
      wrap.insertBefore(frame, fallback);
    }
    return frame;
  }

  function setLayer(dialog, layer) {
    var loading = qs('[data-pdf-loading]', dialog);
    var frame = qs('[data-pdf-iframe]', dialog);
    var fallback = qs('[data-pdf-fallback]', dialog);
    var canvas = qs('[data-pdf-canvas]', dialog);
    if (loading) loading.hidden = layer !== 'loading';
    if (fallback) fallback.hidden = layer !== 'fallback';
    if (canvas) canvas.hidden = true;
    if (frame) {
      var show = layer === 'iframe';
      frame.hidden = !show;
      if (show) frame.removeAttribute('hidden');
      else frame.setAttribute('hidden', '');
    }
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
    lockScroll(false);
    var rootId = dialog.getAttribute('data-pdf-root-id');
    if (rootId) {
      var root = document.getElementById(rootId);
      if (root) root.dataset.pdfBusy = '0';
    }
  }

  function loadPdfPreview(root, dialog) {
    var url = resolvePdfUrl(root, dialog);
    if (!url) {
      setLayer(dialog, 'fallback');
      return;
    }
    root.setAttribute('data-pdf-url', url);

    var frame = ensureIframe(dialog);
    if (!frame) {
      setLayer(dialog, 'fallback');
      return;
    }

    setLayer(dialog, 'loading');

    var viewerSrc = url.split('#')[0] + '#toolbar=0&navpanes=0&scrollbar=1&view=FitH';
    var settled = false;

    function finish(layer) {
      if (settled) return;
      settled = true;
      root.dataset.pdfBusy = '0';
      setLayer(dialog, layer);
    }

    frame.onload = function () {
      finish('iframe');
    };

    frame.onerror = function () {
      finish('fallback');
    };

    frame.src = viewerSrc;
    window.setTimeout(function () {
      finish('iframe');
    }, 6000);
  }

  window.plcPdfOpen = function (btn, event) {
    if (!btn) return false;
    var root = btn.closest('[data-pdf-hub], [data-pdf-preview]');
    if (!root) return false;
    var dialog = qs('[data-pdf-dialog]', root);
    if (!dialog || typeof dialog.showModal !== 'function') return false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    dialog.setAttribute('data-pdf-root-id', root.id || '');

    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    try {
      if (!dialog.open) {
        dialog.showModal();
        document.documentElement.classList.add('overflow-hidden');
      }
      root.dataset.pdfBusy = '1';
      loadPdfPreview(root, dialog);
    } catch (err) {
      setLayer(dialog, 'fallback');
      root.dataset.pdfBusy = '0';
    }
    return false;
  };

  document.addEventListener(
    'click',
    function (e) {
      var openBtn = e.target.closest('[data-pdf-open]');
      if (openBtn) {
        window.plcPdfOpen(openBtn, e);
        return;
      }
      var closeBtn = e.target.closest('[data-pdf-close]');
      if (closeBtn) {
        var dialog = closeBtn.closest('[data-pdf-dialog]');
        if (dialog) {
          e.preventDefault();
          e.stopPropagation();
          closeDialog(dialog);
        }
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var openDialog = document.querySelector('[data-pdf-dialog][open]');
      if (openDialog) closeDialog(openDialog);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var dialog = e.target.closest('[data-pdf-dialog]');
      if (dialog && e.target === dialog) closeDialog(dialog);
    },
    true
  );

  document.addEventListener(
    'close',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-pdf-dialog]')) {
        document.documentElement.classList.remove('overflow-hidden');
      }
    },
    true
  );
})();

(function () {
  if (!document.querySelector('.shopify-policy__container')) return;
  var css =
    '.shopify-policy__container .shopify-policy__body .rte h2,' +
    '.shopify-policy__container .shopify-policy__body .rte h3,' +
    '.shopify-policy__container .shopify-policy__body .rte>p>strong:only-child{' +
    'display:block;font-size:clamp(1.375rem,2.8vw,1.625rem);font-weight:700;line-height:1.35;' +
    'color:#1a365d;margin:2.25rem 0 1rem!important;padding-bottom:.5rem;border-bottom:2px solid #e2e8f0}' +
    '.shopify-policy__container .shopify-policy__body .rte ul,' +
    '.shopify-policy__container .shopify-policy__body .rte ul.list-paddingleft-2{' +
    'list-style:none!important;padding-left:0!important;margin:0 0 1.25rem!important}' +
    '.shopify-policy__container .shopify-policy__body .rte ul li{' +
    'position:relative;padding:.65rem 0 .65rem 1.6rem!important;' +
    'border-bottom:1px solid #edf2f7;list-style:none!important}' +
    '.shopify-policy__container .shopify-policy__body .rte ul li::before{' +
    'content:""!important;position:absolute;left:.15rem;top:1rem;' +
    'width:7px;height:7px;background:#1a365d;border-radius:50%}' +
    '.shopify-policy__container .shopify-policy__body .rte ul li>p{' +
    'margin:0!important;display:inline!important}';
  var style = document.createElement('style');
  style.id = 'policy-page-fix';
  style.textContent = css;
  document.head.appendChild(style);
})();
